import { useApp } from 'context/app-context'
import { ChannelName } from 'lib/pusher'
import { Channel } from 'pusher-js'
import { useEffect, useState } from 'react'

/**
 * Handles the subscribe and unsubscribe lifecycle of the
 * requested Pusher channel name.
 *
 * @param channelName The Pusher channel name. See CHANNELS in the pusher lib
 */
export default function useChannel(channelName: ChannelName): Channel {
  const [channel, setChannel] = useState<Channel>(null)
  const { pusherClient } = useApp()

  useEffect(() => {
    setChannel(pusherClient.subscribe(channelName))
    return () => {
      setChannel(null)
      pusherClient.unsubscribe(channelName)
    }
  }, [])

  return channel
}
